const STREAM_ADMIN_ROLE = 'admin'
const STREAM_USER_ROLE = 'user'

export { STREAM_ADMIN_ROLE, STREAM_USER_ROLE }
